/**
 * [INPUT]: 依赖 clsx 条件类名与 tailwind-merge 冲突消解
 * [OUTPUT]: 对外提供 cn 类名合并函数
 * [POS]: ui 原子层的唯一类名工具，所有 shadcn 风格组件共享
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
